import { isType, omit } from '@ricoh/ria.client.core/utils/data/object';

import type { SeparationOptions, SeparationOptionsBarCode, StartNewDocumentTypeWhen } from '~/common/model/api/separation-profile';

import type { TransformSeparationOptions, TransformStartNewDocumentTypeWhen } from './_separation.type';

/**
 * Prepare SeparationOptions.
 *
 * @param {TransformSeparationOptions} options Transform SeparationOptions.
 *
 * @returns {SeparationOptions} SeparationOptions.
 */
export function prepareSeparationOptions(options: TransformSeparationOptions): SeparationOptions {
  if (options.separation === 'barCode') {
    const { when, ...startNewDocument } = options.startNewDocument;

    return {
      $is: options.separation,
      ...omit(options, 'separation'),
      startNewDocument: {
        $is: when,
        ...startNewDocument,
      } as StartNewDocumentTypeWhen,
    };
  }

  return {
    $is: options.separation,
    ...omit(options, 'separation'),
  } as SeparationOptions;
}

/**
 * Transform SeparationOptions.
 *
 * @param {SeparationOptions} options SeparationOptions.
 *
 * @returns {TransformSeparationOptions} Transformed SeparationOptions.
 */
export function transformSeparationOptions(options: SeparationOptions): TransformSeparationOptions {
  if (isType<SeparationOptionsBarCode>(options, 'barCode')) {
    if (options.startNewDocument.$is === 'barCodeValueIsFound' && typeof options.startNewDocument.values === 'string') {
      options.startNewDocument.values = [options.startNewDocument.values];
    }

    return {
      separation: options.$is,
      ...omit(options, '$is'),
      startNewDocument: {
        when: options.startNewDocument.$is,
        ...omit(options.startNewDocument, '$is'),
      } as TransformStartNewDocumentTypeWhen,
    };
  }

  return {
    separation: options.$is,
    ...omit(options, '$is'),
  } as TransformSeparationOptions;
}
